const MuiAvatar = {
  styleOverrides: {
    root: {
      height: 32,
      width: 32,
      fontSize: 16
    }
  },
  defaultProps: {}
};
export {
  MuiAvatar
};
//# sourceMappingURL=MuiAvatar.js.map
